import { menus } from '@/constants/menus';
import { permissions } from '@/constants/permissions';
import { isRouteWithin } from '@/lib/route-match';
import type { IMenu } from '@/types/menu';
import type { AccessKey } from '@/types/permission';
import { replace } from 'react-router';

export async function permissionsLoader({ request }: { request: Request }) {
  const url = new URL(request.url);
  const currentRoute = url.pathname;

  let currentMenu: IMenu | undefined;
  let parentMenu: IMenu | undefined;

  for (const menu of menus) {
    if (menu.children) {
      const matchedChild = menu.children.find(child =>
        isRouteWithin(currentRoute, child.route)
      );
      if (matchedChild) {
        currentMenu = matchedChild;
        parentMenu = menu;
        break;
      }
    } else if (isRouteWithin(currentRoute, menu.route)) {
      currentMenu = menu;
      break;
    }
  }

  if (!currentMenu) {
    console.error('No matching menu found for:', currentRoute);
  }

  const authRaw = localStorage.getItem('auth');
  if (authRaw) {
    const authParsed = JSON.parse(authRaw);
    const roleName: AccessKey = authParsed?.state?.user?.role?.name ?? 'Admin';
    const permissionAllowed = permissions[roleName];

    const perms = permissionAllowed[currentMenu?.key ?? ''];

    const parentPerms = parentMenu?.key
      ? permissionAllowed[parentMenu.key]
      : undefined;

    const companyId: string | undefined = authParsed?.state?.user?.company?.id;

    const checkCanAccess = () => {
      if (parentPerms && !parentPerms.canView) {
        return false;
      }

      if (currentMenu?.availableTo && !currentMenu.availableTo(companyId)) {
        return false;
      }

      if (currentRoute === currentMenu?.route) {
        return perms?.canView;
      }

      if (currentRoute.endsWith('form')) {
        return perms?.canCreate;
      }

      if (currentRoute.includes('/edit/') || currentRoute.endsWith('/edit')) {
        return perms?.canEdit;
      }

      return perms?.canView;
    };

    const canAccess = checkCanAccess();

    if (!canAccess) {
      throw replace('/unauthorized');
    }
  }

  return { currentMenu, parentMenu };
}
